import SlidingCapacityDTO from 'features/contracts/dtos/SlidingCapacityDTO'
import NumberFormatter from 'features/shared/components/formatters/NumberFormatter';
import { formatDate } from 'features/shared/helpers/Formatters';
import React from 'react';
import styles from './capacityGasSliding.module.scss';

type Props = {
  capacity: SlidingCapacityDTO;
}

const CapacityGasSliding = ({ capacity }: Props) => {
  // helpers
  const getDatePeriod = (date: Date): string => { 
    return `${formatDate(date, { day: "numeric", month: "numeric" })}`;
  }

  // render
  return (
    <div className="d-flex flex-wrap align-items-center justify-content-center">
      <span className='mr-1'>
        <NumberFormatter amount={capacity.slidingReservedCapacity!} />
        <span className="d-sm-none small"> m<sup>3</sup></span>
      </span>
      <span className={`text-muted ${styles.date}`}>
        ({getDatePeriod(capacity.from!)} - {getDatePeriod(capacity.to!)})
      </span>
    </div>
  )
}

export default CapacityGasSliding